/**
 * @generated SignedSource<<cc74deb992a1bd63703c7cfdc8fbc050>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerItemsList_viewer$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerItemsListItem_item">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskSellerItemsList_viewer";
};
export type GetHelpZendeskSellerItemsList_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerItemsList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerItemsList_viewer">;
};

import GetHelpZendeskSellerItemsListPaginationQuery_graphql from './GetHelpZendeskSellerItemsListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "items"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "dealerPk"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": GetHelpZendeskSellerItemsListPaginationQuery_graphql
    }
  },
  "name": "GetHelpZendeskSellerItemsList_viewer",
  "selections": [
    {
      "alias": "items",
      "args": [
        {
          "kind": "Variable",
          "name": "dealerPk",
          "variableName": "dealerPk"
        },
        {
          "kind": "Literal",
          "name": "includeContextAdmin",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "queryTemplate",
          "value": "dealer.inventory.management"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "-createDate"
        }
      ],
      "concreteType": "ItemsConnection",
      "kind": "LinkedField",
      "name": "__GetHelpZendeskSellerItemsList_items_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GetHelpZendeskSellerItemsListItem_item"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "dabc3a3f7289ca6ed8df88893493f8cc";

export default node;
